import { inject } from "mobx-react";
import { type FunctionComponent, useEffect } from "react";

import Api from "nvent-web/services/Api";
import { useAppAuth0 } from "nvent-web/services/auth0/AppAuth0Context";
import { UserStore } from "nvent-web/stores/User";
import { compose } from "nvent-web/utils/compose";

export interface AppAuth0ConnectorInnerProps {
  api: Api;
  user: UserStore;
}

export const AppAuth0ConnectorInner: FunctionComponent<
  AppAuth0ConnectorInnerProps
> = (props) => {
  const { api, user: userStore } = props;
  const auth0 = useAppAuth0();

  const { isAuthenticated, isLoading: isAuthenticating, user } = auth0;

  useEffect(() => {
    if (!auth0.isLoading) {
      api.setAuth0(auth0);
    }
  }, [api, auth0]);

  useEffect(() => {
    userStore.setAuth0(auth0);
  }, [auth0, userStore]);

  useEffect(() => {
    userStore.setIsAuthenticated(isAuthenticated);
    userStore.setIsAuthenticating(isAuthenticating);
    userStore.setAuth0User(user || null);
  }, [isAuthenticated, isAuthenticating, user, userStore]);

  return null;
};

export const AppAuth0Connector = compose(inject("api", "user"))(
  AppAuth0ConnectorInner
);
